import { Navigate, createBrowserRouter } from "react-router-dom";
import {
  Home,
  Requests,
  CreditInfo,
  Prospect,
  ProspectForm,
  ProspectEdit,
  Sender,
  Receiver,
  Simulators,
  Wallet,
  AdminRedirect,
  Page404,
} from "../pages";
import Auth from "../pages/Auth/Login";

import MainLayout from "../layouts/main";
import { initialPath } from "~misc/paths";
import Simulations from "~pages/Simulators/Simulations";
import SenderEdit from "~pages/Wallet/Sender/Edit/SenderEdit";
import ReceiverEdit from "~pages/Wallet/Receiver/Edit/ReceiverEdit";
import CreditLimit from "~pages/Wallet/CreditInfo";
import ReceiverSenderForm from "../pages/Wallet/ReceiverSender/create";
import NovoProduto from "~pages/Simulators/components/novo-produto/NovoProduto";
import AreaListagem from "~pages/Simulators/components/listagem-cliente/AreaListagem";
import RotaDoDia from "~pages/RouteOptimizationV2/pages/RotaDoDia";
import RotaDoDiaGraficos from "~pages/RouteOptimizationV2/pages/RotaDoDiaGraficos";
import RotaDoDiaVisitas from "~pages/RouteOptimizationV2/pages/RotaDoDiaVisitas";
import FunnelPrincipal from "~pages/Funnel/pages/Principal";
import FunnelMapping from "~pages/FunnelV2/pages/FunnelMapping";
import FunnelTrackMapping from "~pages/FunnelV2/pages/FunnelTrackMapping";
import FunnelNextNegotiations from "~pages/FunnelV2/pages/FunnelNextNegotiations";
import FunnelClientNextNegotiations from "~pages/FunnelV2/pages/FunnelClientNextNegotiations";
import FunnelActiveWorks from "~pages/FunnelV2/pages/FunnelActiveWorks";
import FunnelDashboard from "~pages/Funnel/pages/Dashboard";
import FunnelEdit from "~pages/FunnelV2/components/shared/FunnelEdit";
import PricesTableNegotiation from "~pages/PricesTableV2/pages/negotiation/Negotiation";

import useUsuario from "~/fetchs/useUsuario";
import SynchronizePage from "~pages/Synchronize";
import Teste from "~pages/Teste/Teste";
import EditarProduto from "~pages/Simulators/components/editar-produto/EditarProduto";
import CheckAccessRoute from "./CheckAccessRoute";
import CreateResearch from "~pages/ResearchManagement/Pages/CreateResearch";
import ViewResearch from "~pages/ResearchManagement/Pages/ViewResearch";
import ListResearch from "~pages/ResearchManagement/Pages/ListResearch";
import Links from "~pages/Home/Links";
import Problems from "~pages/Home/Problems";
import ViewForm from "~pages/ResearchManagement/Pages/ViewForm";
import ViewFormHistory from "~pages/ResearchManagement/Pages/ViewFormHistory";
import { PricesTableTabNavigation } from "~pages/PricesTableV2/components";
import MainNegotiations from "~pages/PricesTableV2/pages/main/Negotiations/MainNegotiations";
import AllNegotiations from "~pages/PricesTableV2/pages/main/Negotiations/AllNegotiations";
import CloseToExpire from "~pages/PricesTableV2/pages/main/Negotiations/CloseToExpire";
import RulesPage from "~pages/PricesTableV2/pages/main/rules/RulesPage";
import RequestsPage from "~pages/PricesTableV2/pages/main/requests/RequestsPage";
import { ClientDetailsPage, ClientRequestsPage } from "~pages/PricesTableV2/pages/client";
import priceSearchV2 from "~pages/PriceSearchV2/pages/PriceSearch";
import PriceSearchFormV2 from "~pages/PriceSearchV2/pages/SearchForm";
import { ModalSyncProvider } from "~/context/ModalSyncContext";
import Result from "~pages/Reflex/pages/Result";
import ReflexCurrentMonth from "~pages/Reflex/pages/ReflexCurrentMonth";
import ReflexCurrentQuarter from "~pages/Reflex/pages/ReflexCurrentQuarter";
import TesteComponents from "~pages/SalesManagement/LoadPosition/pages/TesteComponents";
import index from "~pages/SalesManagement/LoadPosition/pages";
import SelfServicesPage from "~pages/SalesManagement/selfservices/pages";
import CustomerCreditPage from "~pages/SalesManagement/CustomerCredit/pages";
import SalesForceIndex from "~pages/SalesManagement/SalesForce/pages";
import BateuLevouLayout from "~pages/SalesManagement/bateulevou/pages";
import VlozPage from "~pages/SalesManagement/vloz/pages";
import Super4Page from "~pages/SalesManagement/super4/pages";
import CarteiraPage from "~pages/SalesManagement/relatoriodevendas/pages/carteira";
import ClientesPage from "~pages/SalesManagement/relatoriodevendas/pages/clientes";
import SalesManagement from "~pages/Home/SalesManagement";
import FunnelNewGroup from "~pages/FunnelV2/pages/FunnelNewGroup";
import FunnelNewMappingGroup from "~pages/FunnelV2/pages/FunnelNewMappingGroup";
import FunnelEditGroup from "~pages/FunnelV2/pages/FunnelEditGroup";

export const noAuthRouter = createBrowserRouter([
  {
    path: "*",
    element: <Auth />,
  },
]);

export const router = createBrowserRouter([
  {
    path: `${initialPath}`,
    element: (
      <ModalSyncProvider>
        <MainLayout />
      </ModalSyncProvider>
    ),
    children: [
      {
        path: `${initialPath}/`,
        element: <CheckAccessRoute element={Home} skipAccessCheck />,
      },
      {
        path: `${initialPath}/links-uteis`,
        element: <CheckAccessRoute element={Links} key={1} accessKey="acesso-ao-menu-de-carteira" />,
      },
       {
        path: `${initialPath}/gestao-de-vendas`,
        element: <CheckAccessRoute element={SalesManagement} key={1} accessKey="acesso-ao-menu-de-gestao-de-vendas" />,
      },

      {
        path: `${initialPath}/problemas-tecnicos`,
        element: <CheckAccessRoute element={Problems} key={1} accessKey="acesso-ao-menu-de-carteira" />,
      },
      {
        path: "/app",
        element: <Navigate to="/" replace />,
      },
      {
        path: "/teste",
        element: <Teste />,
      },
      {
        path: "/admin",
        element: <AdminRedirect />,
      },
      {
        path: "/sincronizar",
        element: <SynchronizePage />,
      },
      //  MODULO 1 - CADASTRO E CRÉDITO
      {
        path: `${initialPath}/cadastro-e-credito`,
        element: (
          <CheckAccessRoute element={Wallet} key={1} accessKey="acesso-ao-menu-de-carteira" hideOthersButtons={true} />
        ),
      },
      {
        path: `${initialPath}/carteira`,
        element: <CheckAccessRoute element={Wallet} key={2} accessKey="acesso-ao-menu-de-carteira" />,
      },
      {
        path: `${initialPath}/carteira/prospect`,
        element: <CheckAccessRoute element={Prospect} key={3} accessKey="acesso-ao-menu-de-carteira" />,
      },
      {
        path: `${initialPath}/carteira/prospect/novo`,
        element: <CheckAccessRoute element={ProspectForm} accessKey="acesso-ao-menu-de-carteira" />,
      },
      {
        path: `${initialPath}/carteira/solicitacoes`,
        element: <CheckAccessRoute element={Requests} accessKey="acesso-ao-menu-de-carteira" />,
      },
      {
        path: `${initialPath}/carteira/emissor/novo`,
        element: <CheckAccessRoute element={Sender} accessKey="acesso-ao-menu-de-carteira" />,
      },
      {
        path: `${initialPath}/carteira/recebedor/novo`,
        element: <CheckAccessRoute element={Receiver} accessKey="acesso-ao-menu-de-carteira" />,
      },
      {
        path: `${initialPath}/carteira/busca/online`,
        element: <CheckAccessRoute element={ReceiverSenderForm} accessKey="acesso-ao-menu-de-carteira" />,
      },
      {
        path: `${initialPath}/carteira/prospect/:parameter`,
        element: <CheckAccessRoute element={ProspectEdit} accessKey="acesso-ao-menu-de-carteira" />,
      },
      {
        path: `${initialPath}/carteira/emissor/:parameter`,
        element: <CheckAccessRoute element={SenderEdit} accessKey="acesso-ao-menu-de-carteira" />,
      },
      {
        path: `${initialPath}/carteira/recebedor/:parameter`,
        element: <CheckAccessRoute element={ReceiverEdit} accessKey="acesso-ao-menu-de-carteira" />,
      },
      {
        path: `${initialPath}/carteira/credito/:parameter`,
        element: <CheckAccessRoute element={CreditLimit} accessKey="acesso-ao-menu-de-carteira" />,
      },
      {
        path: `${initialPath}/carteira/credito/novo`,
        element: <CheckAccessRoute element={CreditInfo} accessKey="acesso-ao-menu-de-carteira" />,
      },
      //  MÓDULO 2 - PESQUISA DE PREÇO - MAPA DA MINA
      {
        path: `${initialPath}/pesquisa-de-preco/:parameter/editar/:number`,
        element: <CheckAccessRoute element={PriceSearchFormV2} key={1} accessKey="acesso-ao-menu-pesquisa-de-preco" />,
      },
      {
        path: `${initialPath}/pesquisa-de-preco/:parameter`,
        element: <CheckAccessRoute element={priceSearchV2} accessKey="acesso-ao-menu-pesquisa-de-preco" />,
      },

      {
        path: `${initialPath}/pesquisa-de-preco/:parameter/nova-pesquisa`,
        element: <CheckAccessRoute element={PriceSearchFormV2} key={2} accessKey="acesso-ao-menu-pesquisa-de-preco" />,
      },
      //  MÓDULO 3 - SIMULADOR DE ENSACADOS
      {
        path: `${initialPath}/simuladores`,
        element: <CheckAccessRoute element={Simulators} accessKey="acesso-ao-menu-de-simuladores" />,
      },
      {
        path: `${initialPath}/simuladores/:parameter/simulacao/:simulacao`,
        element: <CheckAccessRoute element={Simulations} accessKey="acesso-ao-menu-de-simuladores" />,
      },
      {
        path: `${initialPath}/simuladores/:parameter/simulacao-nova`,
        element: <CheckAccessRoute element={Simulations} novaSimulacao accessKey="acesso-ao-menu-de-simuladores" />,
      },
      {
        path: `${initialPath}/simuladores/:parameter/simulacao`,
        element: <CheckAccessRoute element={Simulations} accessKey="acesso-ao-menu-de-simuladores" />,
      },
      {
        path: `${initialPath}/simuladores/simulacao/:parameter/novo-produto`,
        element: <CheckAccessRoute element={NovoProduto} accessKey="acesso-ao-menu-de-simuladores" />,
      },
      {
        path: `${initialPath}/simuladores/simulacao/:parameter/editar`,
        element: <CheckAccessRoute element={EditarProduto} accessKey="acesso-ao-menu-de-simuladores" />,
      },
      {
        path: `${initialPath}/simuladores/simulacoes/:parameter`,
        element: <CheckAccessRoute element={AreaListagem} accessKey="acesso-ao-menu-de-simuladores" />,
      },

      //  MÓDULO 4 - TABELA DE PREÇO
      {
        path: `${initialPath}/tabela-preco`,
        element: <CheckAccessRoute element={PricesTableTabNavigation} accessKey="acesso-ao-menu-de-tabela-de-precos" />,
        children: [
          {
            path: "",
            element: <CheckAccessRoute element={MainNegotiations} accessKey="acesso-ao-menu-de-tabela-de-precos" />,
            children: [
              {
                path: "",
                element: <CheckAccessRoute element={AllNegotiations} accessKey="acesso-ao-menu-de-tabela-de-precos" />,
              },
            ],
          },
          {
            path: "proximas-do-vencimento",
            element: <CheckAccessRoute element={MainNegotiations} accessKey="acesso-ao-menu-de-tabela-de-precos" />,
            children: [
              {
                path: "",
                element: <CheckAccessRoute element={CloseToExpire} accessKey="acesso-ao-menu-de-tabela-de-precos" />,
              },
            ],
          },
          // Rotas sem layout de filtros
          {
            path: "preco-regra",
            element: <CheckAccessRoute element={RulesPage} accessKey="acesso-ao-menu-de-tabela-de-precos" />,
          },
          {
            path: "minhas-solicitacoes",
            element: <CheckAccessRoute element={RequestsPage} accessKey="acesso-ao-menu-de-tabela-de-precos" />,
          },
          {
            path: ":id",
            element: <CheckAccessRoute element={ClientDetailsPage} accessKey="acesso-ao-menu-de-tabela-de-precos" />,
          },
          {
            path: ":id/solicitacoes-preco",
            element: <CheckAccessRoute element={ClientRequestsPage} accessKey="acesso-ao-menu-de-tabela-de-precos" />,
          },

          {
            path: `:id/nova-negociacao`,
            element: (
              <CheckAccessRoute element={PricesTableNegotiation} accessKey="acesso-ao-menu-de-tabela-de-precos" />
            ),
          },
          {
            path: `:id/editar-negociacao`,
            element: (
              <CheckAccessRoute element={PricesTableNegotiation} accessKey="acesso-ao-menu-de-tabela-de-precos" />
            ),
          },
        ],
      },
      //  MÓDULO 5 - FUNIL DE OBRAS
      {
        path: `${initialPath}/funil-de-obras`,
        children: [
          {
            path: ":parameter",
            element: <CheckAccessRoute element={FunnelEdit} accessKey="acesso-ao-menu-de-funil-de-obras" />,
          },
          {
            path: ":parameter/mapeamento",
            element: <CheckAccessRoute element={FunnelMapping} accessKey="acesso-ao-menu-de-funil-de-obras" />,
          },
          {
            path: ":parameter/mapeamento/novo-grupo",
            element: <CheckAccessRoute element={FunnelNewGroup} accessKey="acesso-ao-menu-de-funil-de-obras" />,
          },
          // {
          //   path: ":parameter/editar/:id",
          //   element: <CheckAccessRoute element={FunnelEdit} accessKey="acesso-ao-menu-de-funil-de-obras" />,
          // },
          {
            path: ":parameter/acompanhamento-mapeamento/novo-grupo",
            element: <CheckAccessRoute element={FunnelNewMappingGroup} accessKey="acesso-ao-menu-de-funil-de-obras" />,
          },
          {
            path: ":parameter/acompanhamento-mapeamento",
            element: <CheckAccessRoute element={FunnelTrackMapping} accessKey="acesso-ao-menu-de-funil-de-obras" />,
          },
          {
            path: ":parameter/editar/:id/grupo",
            element: <CheckAccessRoute element={FunnelEditGroup} accessKey="acesso-ao-menu-de-funil-de-obras" />,
          },
          {
            path: ":parameter/proximas-negociacoes",
            element: <CheckAccessRoute element={FunnelClientNextNegotiations} accessKey="acesso-ao-menu-de-funil-de-obras" />,
          },
          {
            path: "proximas-negociacoes",
            element: <CheckAccessRoute element={FunnelNextNegotiations} accessKey="acesso-ao-menu-de-funil-de-obras" />,
          },
          {
            path: "obras-ganhas",
            element: <CheckAccessRoute element={FunnelActiveWorks} accessKey="acesso-ao-menu-de-funil-de-obras" />,
          },
          {
            path: ":parameter/dashboard",
            element: (
              <CheckAccessRoute element={FunnelDashboard} key={2} accessKey="acesso-ao-menu-de-funil-de-obras" />
            ),
          },
        ],
      },
      //  MÓDULO 6 - ROTEIRIZAÇÃO
      // {
      //   path: `${initialPath}/roteirizacao`,
      //   element: <CheckAccessRoute element={RouteOptimization} accessKey="acesso-ao-menu-de-rota-do-dia" />,
      // },
      {
        path: `${initialPath}/roteirizacao/mapa`,
        element: <CheckAccessRoute element={RotaDoDia} accessKey="acesso-ao-menu-de-rota-do-dia" />,
      },
      {
        path: `${initialPath}/roteirizacao/:parameter`,
        element: <CheckAccessRoute element={RotaDoDiaGraficos} accessKey="acesso-ao-menu-de-rota-do-dia" />,
      },
      {
        path: `${initialPath}/roteirizacao/consulta/:parameter`,
        element: <CheckAccessRoute element={RotaDoDiaGraficos} accessKey="acesso-ao-menu-de-rota-do-dia" />,
      },
      {
        path: `${initialPath}/roteirizacao/visitas`,
        element: <CheckAccessRoute element={RotaDoDiaVisitas} accessKey="acesso-ao-menu-de-rota-do-dia" />,
      },
      //  MÓDULO 7 - Gestão de Pesquisa(Formulários)

      {
        path: `${initialPath}/gestao-de-pesquisa`,
        element: <CheckAccessRoute element={ListResearch} accessKey="acesso-ao-menu-de-rota-do-dia" />,
      },
      {
        path: `${initialPath}/gestao-de-pesquisa/formularios/:parameter`,
        element: <CheckAccessRoute element={ViewForm} accessKey="acesso-ao-menu-de-rota-do-dia" />,
      },
      {
        path: `${initialPath}/gestao-de-pesquisa/historico-formularios/:parameter`,
        element: <CheckAccessRoute element={ViewFormHistory} accessKey="acesso-ao-menu-de-rota-do-dia" />,
      },

      {
        path: `${initialPath}/gestao-de-pesquisa/:parameter`,
        element: <CheckAccessRoute element={CreateResearch} accessKey="acesso-ao-menu-de-rota-do-dia" />,
      },
      {
        path: `${initialPath}/gestao-de-pesquisa/visualizar/:parameter`,
        element: <CheckAccessRoute element={ViewResearch} accessKey="acesso-ao-menu-de-rota-do-dia" />,
      },

      {
        path: `${initialPath}/reflex`,
        element: <CheckAccessRoute element={Result} accessKey="acesso-ao-menu-de-reflex" />,
        children: [
          {
            path: "",
            element: <CheckAccessRoute element={Navigate} accessKey="acesso-ao-menu-de-reflex" />,
            children: [
              {
                path: "",
                element: <Navigate to="mes-atual" replace />,
              },
            ],
          },
          {
            path: "mes-atual",
            element: <CheckAccessRoute element={ReflexCurrentMonth} accessKey="acesso-ao-menu-de-reflex" />,
          },
          {
            path: "trimestre-atual",
            element: <CheckAccessRoute element={ReflexCurrentQuarter} accessKey="acesso-ao-menu-de-reflex" />,
          },
        ],
      },
      {
        path: `${initialPath}/reflex/historico`,
        element: <CheckAccessRoute element={Result} accessKey="acesso-ao-menu-de-reflex" />,
      },

       //  MÓDULO 8 - relatório QS

         {
        path: `${initialPath}/gestao-de-vendas/relatorio/teste`,
        element: <CheckAccessRoute element={TesteComponents} accessKey="acesso-ao-menu-de-rota-do-dia" />,
      },

      {
        path: `${initialPath}/gestao-de-vendas/posicao-de-carga/:aba?`,
        element: <CheckAccessRoute element={index} accessKey="acesso-ao-menu-de-posicao-de-carga" />,
      },
      {
        path: `${initialPath}/gestao-de-vendas/autosservico/:aba?`,
        element: <CheckAccessRoute element={SelfServicesPage} accessKey="acesso-ao-menu-de-autosservico" />,
      },
      {
        path: `${initialPath}/gestao-de-vendas/credito-de-clientes/:aba?`,
        element: <CheckAccessRoute element={CustomerCreditPage} accessKey="acesso-ao-menu-de-credito-de-clientes" />,
      },
      {
        path: `${initialPath}/gestao-de-vendas/sales-force`,
        element: <CheckAccessRoute element={SalesForceIndex} accessKey="acesso-ao-menu-de-sales-force" />,
      },

      //  MÓDULO 9 - Programas Comerciais
      {
        path: `${initialPath}/gestao-de-vendas/bateu-levou`,
        element: <CheckAccessRoute element={BateuLevouLayout} accessKey="acesso-ao-menu-de-bateu-levou" />,
      },
      {
        path: `${initialPath}/gestao-de-vendas/vloz`,
        element: <CheckAccessRoute element={VlozPage} accessKey="acesso-ao-menu-de-vloz" />,
      },
      {
        path: `${initialPath}/gestao-de-vendas/super4`,
        element: <CheckAccessRoute element={Super4Page} accessKey="acesso-ao-menu-de-super4" />,
      },

      //  MÓDULO 10 - Relatório de Vendas
      {
        path: `${initialPath}/gestao-de-vendas/relatorio-de-vendas/carteira`,
        element: <CheckAccessRoute element={CarteiraPage} accessKey="acesso-ao-menu-de-relatorio-de-vendas" />,
      },
      {
        path: `${initialPath}/gestao-de-vendas/relatorio-de-vendas/clientes`,
        element: <CheckAccessRoute element={ClientesPage} accessKey="acesso-ao-menu-de-relatorio-de-vendas" />,
      },
    ],
  },

  {
    path: "*",
    element: <Page404 />,
  },
]);
